import FaceMachinePausing from './FaceMachinePausing';

export default FaceMachinePausing;
